<template>
  <div :class="$style.container">
    <span
      v-opacity=".5"
      v-text="$t('common.count')"
    ></span>
    <number-counter
      v-if="isShownCounter"
      :count="countTicket"
      :count-bundle="arrangement.countBundle"
      :count-per-payment="arrangement.countPerPayment"
      @update="value => $emit('update-count', value)"
    />
    <strong
      v-else
      v-text="minCountTicket"
    />
  </div>
</template>

<script>
import NumberCounter from 'molecules/common/NumberCounter';

export default {
  name: 'TicketCounter',
  components: {
    NumberCounter,
  },
  props: {
    arrangement: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isShownCounter() {
      const { countBundle } = this.arrangement;

      if (this.$validate.isPositiveNumber(countBundle)) {
        return false;
      }

      if (this.$validate.isNull(this.minCountTicket)) {
        return true;
      }

      return this.minCountTicket !== 1;
    },
    minCountTicket() {
      const { countBundle, countPerPayment } = this.arrangement;

      if (this.$validate.isPositiveNumber(countBundle)) {
        return countBundle;
      }

      if (this.$validate.isPositiveNumber(this.countTicket)) {
        if (this.$validate.isPositiveNumber(countPerPayment)) {
          return Math.min(this.countTicket, countPerPayment);
        }

        return this.countTicket;
      }

      return countPerPayment;
    },
    countTicket() {
      const { count, countBundle, countSold } = this.arrangement;

      if (this.$validate.isPositiveNumber(countBundle)) {
        return countBundle;
      }

      if (this.$validate.isPositiveNumber(countSold) && this.$validate.isPositiveNumber(count)) {
        return count - countSold;
      }

      return count;
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox
    +align-items(center)
    +justify-content(space-between)
    +font-type(regular, 14, 26)
    color: rgb(33, 33, 33)
</style>
